import { optimoPrivateApi } from '../../axios/axiosInstance'
import { endpoints } from '../../endpoints'

import type { ISubmitFeedbackParams, IFeedbackApiResponse } from './feedbackActions.types'

export const submitFeedback = async (params: ISubmitFeedbackParams): Promise<IFeedbackApiResponse> => {
    const response = await optimoPrivateApi.post<IFeedbackApiResponse>(endpoints.feedback.submit, params)
    return response.data
}
